import { ENDPOINTS, HOSTS } from "@/constants";
import { translate } from "@/i18n";
import { httpClient } from "@/services/httpClient";
import type { AxiosResponse } from "axios";

export const setTableEnable = (aAPEDetail: any[], aapes: any[]) => {
  return aAPEDetail && aAPEDetail.length == aapes.length ? true : false;
};

export const getUnitenergy = (codeEnergy: any): string => {
  switch (codeEnergy) {
    case "ELECTRICITY":
      return translate("economy.MWh");
    case "STEAM":
      return "t vapeur";
    default:
      return translate("economy.MWHPCS");
  }
};

export const addBalanceAape = (bilanInfo: any, perimeters: any[]) => {
  return httpClient
    .post(`${HOSTS.AWS}/${ENDPOINTS.BALANCEAAPE}`, bilanInfo)
    .then(
      (response: AxiosResponse<any>) => {
        const promises = [];
        for (const perimeter of perimeters) {
          const promise = addBalancePerimeter({
            ...perimeter,
            balanceAapeId: response.data.balance_aape_id,
          });
          promises.push(promise);
        }
        return Promise.all(promises);
      },
      (error) => {
        console.log(error);
      },
    );
};
export const editBalanceAape = (bilanInfo: any, id: string, cb: any = null) => {
  return httpClient
    .put(`${HOSTS.AWS}/${ENDPOINTS.BALANCEAAPE}/${id}`, bilanInfo)
    .then(
      () => {
        if (cb != null) {
          cb();
        }
      },
      (error) => {
        console.log(error);
      },
    );
};

export const addBalancePerimeter = (perimeter: any) => {
  return httpClient
    .post(`${HOSTS.AWS}/${ENDPOINTS.BALANCEPERIMETER}`, perimeter)
    .then(
      () => {
        //console.log(response);
      },
      (error) => {
        console.log(error);
      },
    );
};

export const editBalancePerimeter = (perimeter: any, id: string) => {
  return httpClient
    .put(`${HOSTS.AWS}/${ENDPOINTS.BALANCEPERIMETER}/${id}`, perimeter)
    .then(
      () => {
        // console.log(response);
      },
      (error) => {
        console.log(error);
      },
    );
};

export const getAappe = (id: string) => {
  return httpClient
    .get(`${HOSTS.AWS}/${ENDPOINTS.BALANCEAAPE}?aapeId=${id}`)
    .then(
      (response: AxiosResponse<any>) => {
        console.log(response);
      },
      (error) => {
        console.log(error);
      },
    );
};

export const getBilanByProject = async (id: string) => {
  return await httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.BALANCEPROJECT}/${id}`);
};

export const getBilanConsoAjuste = async (
  id: string,
  dateStart: any,
  dateEnd: any,
) => {
  return await httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.GRAPH_DATA}`, {
    params: {
      id: id,
      aggregationId: "607c0373-bb01-4eb8-9d56-0f08b742480b",
      preferredSampling: 10,
      preferredSamplingUnit: "years",
      start: dateStart,
      end: dateEnd,
      limit: 10000,
      timeserie: true,
      type: "variable",
    },
  });
};

export async function processBalanceAapesPerimeters(bilan: any, aapes: any) {
  const requests = [];
  bilan.isPerimeterLoaded = true;
  for (const balance of bilan.balanceAape) {
    const aape = aapes.find((aape: any) => aape.id == balance.aape_id);
    if (balance.balancePerimeters) {
      for (const perimeter of balance.balancePerimeters) {
        const perimeterDetail = aape.perimeters.find(
          (p: any) => p.id === perimeter.perimeter_id,
        );
        if (!perimeterDetail) {
          throw new Error("Perimeter not found");
        }
        requests.push(
          fetchAdditionalData(
            perimeter,
            perimeterDetail,
            balance.balance_start_date,
            balance.balance_end_date,
          ),
        );
      }
    }
  }

  await Promise.all(requests);

  return bilan;
}
export async function processBalanceAapes(
  data: any,
  aapes: any,
  loadAll: boolean,
) {
  const requests = [];

  for (const balanceAape of data.balanceAapes) {
    balanceAape.status = balanceAape.balanceAape[0].status;
    balanceAape.isPerimeterLoaded = false;
    balanceAape.start_date = balanceAape.balanceAape[0].balance_start_date;
    balanceAape.end_date = balanceAape.balanceAape[0].balance_end_date;
    balanceAape.last_date_date_computation =
      balanceAape.balanceAape[0].balance_end_date;

    if (loadAll) balanceAape.isPerimeterLoaded = true;

    for (const balance of balanceAape.balanceAape) {
      const aape = aapes.find((aape: any) => aape.id == balance.aape_id);
      balance.name = aape.name;
      balance.number = aape.number;
      balance.total_energy_commitment = aape.total_energy_commitment;
      if (loadAll) {
        if (balance.balancePerimeters) {
          for (const perimeter of balance.balancePerimeters) {
            const perimeterDetail = aape.perimeters.find(
              (p: any) => p.id === perimeter.perimeter_id,
            );
            if (!perimeterDetail) {
              throw new Error("Perimeter not found");
            }

            // Fetch additional data for consumption_measure_id and saving_measure_id concurrently
            requests.push(
              fetchAdditionalData(
                perimeter,
                perimeterDetail,
                balance.balance_start_date,
                balance.balance_end_date,
              ),
            );
          }
        }
      }
    }
  }

  await Promise.all(requests);

  return data;
}

export async function fetchAdditionalData(
  perimeter: any,
  perimeterDetail: any,
  dateStart: any,
  dateEnd: any,
) {
  const params = {
    aggregationId: "607c0373-bb01-4eb8-9d56-0f08b742480b",
    preferredSampling: 1,
    preferredSamplingUnit: "days",
    start: dateStart,
    end: dateEnd,
    limit: 10000,
    timeserie: true,
    type: "variable",
  };
  const [consumptionResponse, savingResponse, consumptionMeasureResponse] =
    await Promise.all([
      perimeterDetail.consumption_reference_measure_id
        ? httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.GRAPH_DATA}`, {
            params: {
              id: perimeterDetail.consumption_reference_measure_id,
              ...params,
            },
          })
        : null,
      perimeterDetail.saving_measure_id
        ? httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.GRAPH_DATA}`, {
            params: { id: perimeterDetail.saving_measure_id, ...params },
          })
        : null,
      perimeterDetail.consumption_measure_id
        ? httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.GRAPH_DATA}`, {
            params: { id: perimeterDetail.consumption_measure_id, ...params },
          })
        : null,
    ]);

  perimeter.consumption_measure_value_reference =
    checkValueMeasure(consumptionResponse);
  perimeter.saving_measure_value = checkValueMeasure(savingResponse);
  perimeter.consumption_measure_value = checkValueMeasure(
    consumptionMeasureResponse,
  );
  perimeter.energy_fr_translation = perimeterDetail.energy_fr_translation;
  perimeter.energy_en_translation = perimeterDetail.energy_en_translation;
  perimeter.energy_code = perimeterDetail.energy_code;
  perimeter.co2_saving_calc =
    perimeter.saving_measure_value *
    perimeterDetail.ncv_co2eq_emission_coefficient;
  perimeter.number = perimeterDetail.number;
  perimeter.financial_saving_calc =
    perimeter.saving_measure_value * perimeterDetail.contract_energy_price;

  return perimeter;
}

function checkValueMeasure(response: any) {
  let total = 0;
  if (response && response.data) {
    for (const dt of response.data.data) {
      if (dt.value != null && dt.value != undefined) {
        total += dt.value;
      }
    }
  }
  return total == 0 ? total : total.toFixed(2);
}
export async function deleteBalanceAapeAndPerimeters(balanceAape: any) {
  const requests = balanceAape.balanceAape.flatMap((balance: any) =>
    balance.balancePerimeters.map((perimeter: any) =>
      deleteBilanPerimeter(perimeter.balance_perimeter_id),
    ),
  );

  const aapeRequests = balanceAape.balanceAape.map((balance: any) =>
    deleteBilanAappe(balance.balance_aape_id),
  );

  await Promise.all([...requests, ...aapeRequests]);
}

export const deleteBilanAappe = (id: string, cb: any = null) => {
  return httpClient.delete(`${HOSTS.AWS}/${ENDPOINTS.BALANCEAAPE}/${id}`).then(
    () => {
      if (cb != null) cb();
    },
    (error) => {
      console.log(error);
    },
  );
};

export const deleteBilanPerimeter = (id: string) => {
  return httpClient
    .delete(`${HOSTS.AWS}/${ENDPOINTS.BALANCEPERIMETER}/${id}`)
    .then(
      () => {
        //console.log(response);
      },
      (error) => {
        console.log(error);
      },
    );
};
export enum TYPEDATA_BILAN {
  EUROS = "Euros",
  CO2 = "teqCO2",
  MWH = "MWh",
}

export function getUnitMwh(typeEnergy: string) {
  switch (typeEnergy) {
    case "Electricité":
      return translate("economy.MWh");
    case "Électricité":
      return translate("economy.MWh");
    case "Vapeur":
      return translate("economy.MWh");
    default:
      return translate("economy.MWHPCS");
  }
}
export function getMeasureColumn(
  aape: any,
  typeData: TYPEDATA_BILAN,
  isActive = "Active",
) {
  if (isActive == "Active") {
    switch (typeData) {
      case "Euros":
        return aape.financial_saving_calc.toFixed(2);
      case "teqCO2":
        return aape.co2_saving_calc.toFixed(2);
      default:
        return aape.saving_measure_value;
    }
  } else {
    switch (typeData) {
      case "Euros":
        return aape.financial_savings_made.toFixed(2);
      case "teqCO2":
        return aape.perimeterFitCommitmentCO2
          ? aape.perimeterFitCommitmentCO2.toFixed(2)
          : 0;
      default:
        return aape.energy_savings_made;
    }
  }
}

export function getAbsoluteValueColumn(aape: any, typeData: TYPEDATA_BILAN) {
  switch (typeData) {
    case "Euros":
      return aape.total_financial_saving;
    case "teqCO2":
      return aape.total_co2_saving;
    default:
      return aape.total_energy_commitment;
  }
}

export function getEnergyLabelPerimeterByLang(local: string, perimeter: any) {
  if (local) {
    if (local == "fr") return perimeter.energy_fr_translation;
    else {
      return perimeter.energy_en_translation;
    }
  }
  return perimeter.energy_fr_translation;
}
